module.exports = {"230407001":"岭北街道","230407002":"岭南街道","230407003":"沟北街道","230407004":"沟南街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230407.json
// module id = 720
// module chunks = 0